import { GetMessageActionsResponse } from "@accurx/api/apps";
import { httpClient2 } from "@accurx/shared";
import { useQuery } from "@tanstack/react-query";

export const useMessageActionsQuery = (workspaceId?: number | null) => {
    return useQuery({
        queryKey: ["MessageActions", { workspaceId }],
        queryFn: async () => {
            if (workspaceId) {
                return await httpClient2
                    .get({
                        path: `/api/apps/workspace/:workspaceId/message-actions`,
                        params: { workspaceId },
                    })
                    .json<GetMessageActionsResponse>();
            }
            return { actions: [] };
        },
        staleTime: Infinity,
    });
};
